import { Button, ControlLabel, FormControl, FormGroup } from "react-bootstrap";
import { FormattedMessage, injectIntl } from "react-intl";
import React, { Component } from "react";

import CompanySelectSiren from "../Company/CompanySelectSiren";
import CountrySelect from "../Country/CountrySelect";

class SupplierFormInfos extends Component {
  constructor() {
    super();

    this.state = {
      showSirenSearch: false
    };
  }
  componentDidUpdate(prevProps) {
    // console.log("componentDidUpdate", prevProps);
    if (prevProps.countryCode !== this.props.countryCode) {
      // console.log("UPDATE supplier country");
      this.props.updateFormValue("country", {
        label: "",
        value: this.props.getCountry.country.id
      });
    }
  }

  toggleSiren = () => {
    this.setState({ showSirenSearch: true });
  };
  render() {
    console.log("SupplierFormInfos", this.props);
    const { name, address, country, updateFormValue } = this.props;

    return (
      <div>
        <h4>
          <FormattedMessage id="ids_infos" />
        </h4>
        <FormGroup>
          <ControlLabel>
            <FormattedMessage
              id="ids_name"
              description="supplier name input field label"
              defaultMessage="Nom"
            />
          </ControlLabel>
          {this.state.showSirenSearch ? (
            <CompanySelectSiren
              value={name}
              autoFocus={this.props.focusNameInput}
              onSelected={value => {
                this.props.handleOnSelected(value);
                this.setState({ showSirenSearch: false });
              }}
            />
          ) : (
            <FormControl
              name="name"
              value={name}
              onChange={e => updateFormValue("name", e.target)}
            />
          )}
          <Button
            title={this.props.intl.formatMessage({ id: "ids_searchSiren" })}
            name="test"
            onClick={this.toggleSiren}>
            <i className="fa fa-search" />
          </Button>
        </FormGroup>
        <FormGroup>
          <ControlLabel>
            <FormattedMessage
              id="ids_address"
              description="supplier address input field label"
              defaultMessage="Adresse"
            />
          </ControlLabel>
          <FormControl
            componentClass="textarea"
            rows="6"
            name="adresse"
            id="address"
            value={address}
            placeholder="Adresse"
            onChange={event => updateFormValue("address", event.target)}
          />
        </FormGroup>
        <FormattedMessage id="ids_country">
          {placeholder => (
            <div>
              <FormGroup>
                <ControlLabel>{placeholder}</ControlLabel>
                <CountrySelect
                  required
                  value={country}
                  onSelected={e => updateFormValue("country", e)}
                  placeholder={placeholder}
                />
              </FormGroup>
            </div>
          )}
        </FormattedMessage>
      </div>
    );
  }
}

export default injectIntl(SupplierFormInfos);
